'use client';

import { useEffect } from 'react';
import { setLogLevel, LogLevel } from 'livekit-client';

// Silence LiveKit SDK at module import time
try {
  setLogLevel(LogLevel.silent);
} catch (_) {}

export function ConsoleSilencer() {
  useEffect(() => {
    try {
      setLogLevel(LogLevel.silent);
    } catch (_) {}
  }, []);

  return null;
}
